import { CommunicationChannelEnum, IBaseEntity } from '../common';
import { CompanyStatusEnum, CompanyTypeEnum } from '../company';
import { IApartmentWifiFromConfig } from './apartment-wifi-from-config.interface';
import { IVaWidgetCategory } from './va-widget-category.interface';
import { IWorkingHours } from './working-hours.interface';

/**
 * Configuration object describing the entire Visitors Area for a company.
 */
export interface IVisitorsArea extends IBaseEntity {
  name: string;
  companyId: string;
  mainComponent: CompanyTypeEnum;
  readonly domain?: string;
  subdomain?: string;
  accentColor?: string;
  readonly url?: string;
  readonly subdomainLocked?: boolean;
  topMessage?: Record<string, string>;
  topMessage2?: Record<string, string>;
  languages?: string[];
  logotype?: string;
  // @deprecated
  communication?: { [key in CommunicationChannelEnum]?: string };
  widgets: IVaWidgetCategory[];
  companyStatus?: CompanyStatusEnum;
  companyPlan?: string;
  companyModules?: string[];
  myGuestAgentId?: string;
  companyTimezone?: string;
  lastPublishedAt?: Date;
  lastDraftSavedAt?: Date;
  lastPublishBy?: IVisitorsAreaPublishBy;
  coverType?: CoverTypeEnum;
  visualCover?: IVisualCover[];
  brightLogo?: string;
  brightLogoOriginal?: string;
  logotypeOriginal?: string;
  readonly secured?: boolean;
  isRegistrationEnabled?: boolean;
  companyRooms?: { roomNo: number }[];
  workingHours: IWorkingHours;
  wifi?: IApartmentWifiFromConfig[];
}

/** Details about the user who published the last version of the Visitors Area. */
export interface IVisitorsAreaPublishBy {
  id: string;
  displayName?: string;
  email?: string;
  phone?: string;
}

/** Visual appearance of the Visitors Area landing page when using the visual cover type. */
export interface IVisualCover {
  font: CoverFontEnum;
  video?: string;
  background: string;
  backgroundOriginal: string;
  subtitle: Record<string, string>;
  title: Record<string, string>;
}

/** Supported cover styles for the Visitors Area landing page. */
export enum CoverTypeEnum {
  Simple = 'Simple',
  Visual = 'Visual',
}

/** Font presets used within the visual cover. */
export enum CoverFontEnum {
  Default = 'Default',
  Calligraphic = 'Calligraphic',
  Strong = 'Strong',
}
